import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { useFormik } from 'formik'
import { Button } from '@mui/material'
import CustomTable from '@/product/components/molecules/CustomTable'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import ProductContext from '@/product/context/product/productContext'
import BidContext from '@/product/context/bid/bidContext'
import CommonContext from '@/product/context/common/commonContext'
import ReportContext from '@/product/context/report/reportContext'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { mapData, capitalize } from '@/product/common/components'
import { isValidHttpUrl } from '@/custom/common/components'

const BidHistory = (props) => {
    const productContext = useContext(ProductContext)
    const bidContext = useContext(BidContext)
    const {
        search_allbidhistory,
        getAllBidHistory,
        clearResponse: clearAllBidHistory,
    } = productContext
    const {
        bidCancel,
        bidAward,
        responseStatus: responseStatusBid,
    } = bidContext

    const { t } = useTranslation()
    const [changeStatus, setChangeStatus] = React.useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const commonContext = useContext(CommonContext)
    const { bidHistoryValue, clearBidHistoryValue } = commonContext

    const propsBidHistoryValue = props.data || {}

    const { getAllExportDownload } = useContext(ReportContext)

    const [tableBody, setTableBody] = useState([])
    const [projectData, setProjectData] = useState(null)
    const [data, setData] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const [showDeclined, setShowDeclined] = useState(false)
    const toggleDecline = () => {
        formikData.values.page = 1
        setShowDeclined(!showDeclined)
        formikData.values.declined = !showDeclined
        getAllBidHistory(formikData.values, 'UserProjectBidHistory')
    }

    const formikData = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            get_proxy: false,
            declined: false,
            delete_bid: true,
            award_bid: false,
            show_declined: false,
            project: props.project || 'NPS',
            filters: {
                project_id: {
                    value: 0,
                    type: 'in',
                    field: 'b.project_id',
                },
                user_id: {
                    value: '',
                    type: 'in',
                    field: 'b.user_id',
                },
                proposal: {
                    value: 'tie_bid',
                    type: 'notin',
                    field: 'b.proposal',
                },
                auctionid: {
                    field: 'p.auctionid',
                    value: '',
                    type: 'in',
                },
                market_status: {
                    field: 'p.market_status',
                    type: 'arrayinmultiple',
                    value: '',
                },
            },
        },
        onSubmit: (values) => {
            getCreditHistory(values)
        },
    })
    useEffect(() => {
        if (props.projectId || propsBidHistoryValue) {
            if (propsBidHistoryValue.id) {
                formikData.values.page = 1
                formikData.values.filters.project_id.value =
                    props.projectId || propsBidHistoryValue.id
                formikData.values.get_proxy =
                    propsBidHistoryValue.proxy || false
                formikData.values.filters.auctionid.value = ''
                formikData.values.filters.market_status.value = ''
                if (propsBidHistoryValue.declined) {
                    formikData.values.declined =
                        propsBidHistoryValue.declined || false
                } else {
                    formikData.values.declined = false
                }
                console.log(
                    'propsBidHistoryValue.delete_bid',
                    propsBidHistoryValue.delete_bid
                )
                formikData.values.delete_bid =
                    propsBidHistoryValue.delete_bid &&
                    propsBidHistoryValue.delete_bid === true
                        ? true
                        : false
                formikData.values.award_bid =
                    propsBidHistoryValue.award_bid &&
                    propsBidHistoryValue.award_bid === true
                        ? true
                        : false

                formikData.values.show_declined =
                    propsBidHistoryValue.show_declined &&
                    propsBidHistoryValue.show_declined === true
                        ? true
                        : false
                if (propsBidHistoryValue.user_id) {
                    formikData.values.filters.user_id.value =
                        propsBidHistoryValue.user_id
                } else {
                    formikData.values.filters.user_id.value = ''
                }
                if (
                    propsBidHistoryValue.getBidByAuction &&
                    global.additionalBidHistory
                ) {
                    formikData.values.get_bid_auction = true
                    formikData.values.filters.project_id.value = ''
                    formikData.values.filters.auctionid.value =
                        propsBidHistoryValue.id
                    if (propsBidHistoryValue.market_status == 'closed') {
                        formikData.values.filters.market_status.value =
                            'sold,closed'
                        formikData.values.filters.market_status.type =
                            'arrayinmultiple'
                    } else {
                        formikData.values.filters.market_status.value =
                            propsBidHistoryValue.market_status
                        formikData.values.filters.market_status.type = 'in'
                    }
                } else {
                    formikData.values.get_bid_auction = false
                    formikData.values.filters.auctionid.value = ''
                }
                if (propsBidHistoryValue.show_tiebid) {
                    formikData.values.filters.proposal.value = ''
                } else {
                    formikData.values.filters.proposal.value = 'tie_bid'
                }

                getAllBidHistory(formikData.values, 'UserProjectBidHistory')

                setData(propsBidHistoryValue)
            }
        }
        return () => {
            // clearBidHistoryValue()
            // setShowDeclined(false)
        }
    }, [propsBidHistoryValue])

    useEffect(() => {
        if (search_allbidhistory.from === 'UserProjectBidHistory') {
            if (search_allbidhistory.records.length) {
                search_allbidhistory.records.map((item) => {
                    if (item.bidtopstatus) {
                        item.bidtopstatus =
                            item.bidtopstatus == 'lost'
                                ? 'Lost'
                                : item.bidtopstatus == 'won'
                                ? 'Won'
                                : item.bidtopstatus == 'winner'
                                ? 'Winning'
                                : item.bidtopstatus == 'outbid'
                                ? 'Currently Outbid'
                                : 'No Bids'
                    }
                })

                setTableBody(search_allbidhistory.records)
            } else {
                setTableBody([])
                //setTableBody(search_allbidhistory.records.length ? search_allbidhistory.records : [])
            }

            if (search_allbidhistory.projectRecords) {
                setProjectData(search_allbidhistory.projectRecords)
            }
        }
    }, [search_allbidhistory])

    let tableValues = []

    if (!props.no_userid) {
        tableValues.push({
            field: 'user_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: t('User ID'),
            filterable: true,
            filterField: 'b.user_id',
        })
    }
    tableValues.push({
        field: 'created_at',
        type: props.second ? 'datetime' : 'datetimesecond',
        firstChild: true,
        sort: false,
        disablePadding: false,
        label: t('Date'),
        filterable: true,
        filterField: 'b.created_at',
    })
    tableValues.push({
        field: 'users_first_name',
        type: '',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: t('User First Name'),
        filterable: true,
        filterField: 'u.first_name',
    })
    tableValues.push({
        field: 'users_last_name',
        type: '',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: t('User Last Name'),
        filterable: true,
        filterField: 'u.last_name',
    })
    if (!props.show_company) {
        tableValues.push({
            field: 'users_companyname',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('Company Name'),
            filterable: true,
            filterField: 'u.companyname',
        })
    }

    tableValues.push({
        field: 'users_email',
        type: '',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: t('User Email'),
        filterable: true,
        filterField: 'u.email',
    })

    if (formikData.values.declined) {
        tableValues.push({
            field: 'bidtext',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'declined',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Retracted',
                },
                false: {
                    type: 'text',
                    value: 'Valid',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: t('Status'),
        })
        tableValues.push({
            field: 'bid_retract_logs_created_at',
            type: 'datetime',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: t('Retracted On'),
        })
        tableValues.push({
            field: 'brl_first_name,brl_last_name',
            type: 'text',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: t('Retracted By'),
        })
    }

    if (formikData.values.get_proxy) {
        tableValues.push({
            field: 'bidtext',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'proxytable',
                    key2: 1,
                    notation: '==',
                },
                true: {
                    type: 'text',
                    value: 'Max',
                },
                false: {
                    type: 'value',
                    value: 'bidText',
                },
            },
            type: 'condition',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: t('Type'),
        })
    }

    tableValues.push({
        field: 'proposed_amount',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: t('Amount'),
        filterable: true,
        filterField: 'b.proposed_amount',
    })

    if (formikData.values.award_bid) {
        if (projectData && projectData.market_status === 'open') {
        } else {
            tableValues.push({
                field: 'bidtext',
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'awarded',
                        key2: 1,
                        notation: '===',
                    },
                    true: {
                        type: 'text',
                        value: 'Winner',
                    },
                    false: {
                        type: 'text',
                        value: 'Lost',
                    },
                },
                type: 'text',
                sort: true,
                firstChild: false,
                disablePadding: false,
                label: t('Type'),
            })
        }
    }
    if (formikData.values.get_bid_auction && global.additionalBidHistory) {
        tableValues = global.additionalBidHistory
    }
    const validationArray = Yup.object({
        notes: Yup.string().when(['action'], {
            is: (a) => a == 'delete',
            then: Yup.string().required('Required'),
        }),
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: '',
            pid: '',
            notes: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.action === 'delete') {
                // setIsLoading(true)
                bidCancel(values, 'UserProjectBidCancel')
            } else if (values.action === 'award') {
                // setIsLoading(true)
                bidAward(values)
            }
        },
    })

    const onClickEdit = (id, secondaryID, type) => {
        formikSelection.values.action = type
        formikSelection.values.id = id
        formikSelection.values.pid =
            props.projectId || formikData.values.filters.project_id.value
        if (type === 'delete' || type === 'award') {
            setChangeStatus(true)
        }
    }
    const notesField = {
        formik: formikSelection,
        data: [
            {
                label: 'Notes',
                type: 'textarea',
                placeholder: 'Enter notes',
                class: 'col-12',
                name: 'notes',
            },
        ],
    }

    const getMultipleAction = () => {
        let actionPush = []
        if (formikData.values.delete_bid && !showDeclined) {
            actionPush.push({
                field: 'action',
                type: 'button',
                clickType: 'delete',
                onclick: onClickEdit,
                sort: false,
                firstChild: false,
                disablePadding: false,
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'proxytable',
                        key2: 0,
                        notation: '==',
                    },
                },
                label: t('Action'),
                tooltipTitle: 'Delete Bid',
                buttonType: 'delete',
            })
        }

        if (formikData.values.award_bid) {
            if (projectData && projectData.market_status === 'open') {
                actionPush.push({
                    field: 'action',
                    type: 'button',
                    clickType: 'award',
                    onclick: onClickEdit,
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: t('Action'),
                    tooltipTitle: 'Award Bid',
                    buttonType: 'emoji_events',
                })
            }
        }

        return actionPush
    }

    if (
        (formikData.values.delete_bid &&
            !showDeclined &&
            projectData &&
            projectData.market_status === 'open') ||
        (formikData.values.award_bid &&
            projectData &&
            projectData.market_status === 'open')
    ) {
        let actionIndex = tableValues.findIndex((e) => e.field === 'action')
        if (actionIndex === -1) {
            tableValues.push({
                name: 'action',
                field: 'action',
                type: 'button',
                isMultiple: true,
                clickID: 'id',
                sort: false,
                firstChild: false,
                disablePadding: false,
                label: t('Action'),
                isMultiple: getMultipleAction(),
                tableShow: 1,
            })
        }
    }

    useEffect(() => {
        if (responseStatusBid) {
            if (
                responseStatusBid.from === 'UserProjectBidCancel' ||
                responseStatusBid.from === 'bidAward'
            ) {
                if (responseStatusBid.status === 'success') {
                    // changeChangeStatus()
                    setChangeStatus(false)
                    formikSelection.values.notes = ''
                    formikData.values.filters.project_id.value =
                        props?.projectId || propsBidHistoryValue?.id
                    getAllBidHistory(formikData.values, 'UserProjectBidHistory')
                }
            }
        }
    }, [responseStatusBid])

    const tableActions = []

    let warHouse = []
    let warHouseExport = {}
    if (formikData.values.get_bid_auction && global.additionalBidHistory) {
        global.additionalBidHistory.map((spaceDog) => {
            warHouse.push({
                name: spaceDog.label,
                field: spaceDog.field,
                type: 'text',
            })
            warHouseExport[spaceDog.field] = {
                name: spaceDog.label,
                field: spaceDog.field,
                type: 'text',
            }
        })
    }

    const handleCloseFullScreen = () => {
        setData({ ...data, popup: false })
        if (props?.formik && props?.fromVariable) {
            getAllBidHistory(
                props?.formik?.values,
                props?.fromVariable || 'UserBidHistory'
            )
        }
    }

    return props.noModal ? (
        <CustomTable
            formik={formikData.values}
            tableBody={tableBody}
            tableValues={tableValues}
            tableActions={tableActions}
            allData={search_allbidhistory}
            changeTableFunction={getAllBidHistory}
            fromVariable="UserProjectBidHistory"
            hideCompactView={true}
        />
    ) : (
        data.popup && (
            <FullScreenPopup
                modaltitle={t(`Bid History`)}
                open={data.popup === true}
                handleClose={() => handleCloseFullScreen()}
            >
                <div className="wallet">
                    <div className="fspBody">
                        <div className="bhTopInfo">
                            {projectData ? (
                                <div className="bhProdDetails">
                                    <div className="bhpLt">
                                        <img
                                            src={
                                                isValidHttpUrl(
                                                    projectData.avatar
                                                )
                                                    ? `${projectData.avatar}`
                                                    : `${global.images_url}${projectData.avatar}`
                                            }
                                            alt={projectData?.title}
                                            onError={(e) =>
                                                (e.target.src =
                                                    '/assets/images/noimage.png')
                                            }
                                        />
                                    </div>
                                    <div className="bhpRt">
                                        <h6>
                                            Inventory ID:{' '}
                                            <span>{projectData?.id}</span>
                                        </h6>
                                        <h6>
                                            Inventory Title:{' '}
                                            <span>{projectData?.title}</span>
                                        </h6>
                                        <h6>
                                            Inventory Status:{' '}
                                            <span>
                                                {capitalize(
                                                    projectData?.market_status
                                                )}
                                            </span>
                                        </h6>
                                    </div>
                                </div>
                            ) : null}

                            {/* <Button
                                id="bid_history"
                                variant="outlined"
                                onClick={() =>
                                    getAllExportDownload({
                                        action: 'export',
                                        order: 'asc',
                                        orderby: '',
                                        search: formikData.values
                                            .get_bid_auction
                                            ? `p.auctionid=${formikData.values.filters.auctionid.value}`
                                            : `b.project_id=${
                                                  props.projectId ||
                                                  formikData.values.filters
                                                      .project_id.value
                                              }`,
                                        report: `bid_history`,
                                        get_bid_auction: formikData.values
                                            .get_bid_auction
                                            ? true
                                            : false,
                                        report_action: formikData.values
                                            .get_bid_auction
                                            ? 'download'
                                            : '',
                                        projectID:
                                            props.projectId ||
                                            formikData.values.filters.project_id
                                                .value,
                                        showAuctionName: true,
                                        fields: warHouseExport,
                                        market_status:
                                            formikData.values.filters
                                                .market_status.value,
                                    })
                                }
                            >
                                {' '}
                                <span className="material-icons">get_app</span>
                                {t('Export All Data')}
                            </Button> */}
                        </div>
                        {formikData.values.show_declined ? (
                            <div className="text-right">
                                <FormControlLabel
                                    id={'show_declined'}
                                    label={'Show Retracted'}
                                    control={
                                        <Switch
                                            checked={showDeclined}
                                            onChange={toggleDecline}
                                        />
                                    }
                                />
                            </div>
                        ) : null}

                        <CustomTable
                            formik={formikData.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={search_allbidhistory}
                            changeTableFunction={getAllBidHistory}
                            fromVariable="UserProjectBidHistory"
                        />
                    </div>
                </div>
                <CustomDialog
                    title={'Change Bid Status'}
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    {formikSelection.values.action === 'award' ? (
                        <h5>Are you sure you want to award the bid</h5>
                    ) : (
                        <h5>Are you sure you want to delete the bid</h5>
                    )}
                    {formikSelection.values.action === 'delete' ? (
                        <div className="row">{mapData(notesField)}</div>
                    ) : null}

                    <div className="actionWrapper">
                        <Button
                            id="bidHistory_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="bidHistory_submit"
                                type="submit"
                                label="Confirm"
                            />
                        </form>
                    </div>
                </CustomDialog>
            </FullScreenPopup>
        )
    )
}

export default BidHistory
